import { capab1, capab2, capab3 } from "../../../assets";
import CapaCard from "./capaCard";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { useState, forwardRef } from "react";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Button } from "antd";

import "swiper/css";
import "swiper/css/effect-flip";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { EffectFlip, Pagination, Navigation } from "swiper/modules";
import { getStrapiMedia } from "../../../helpers/tranformers";
const Capabilities = forwardRef(({ content }, ref) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [swiperRef, setSwiperRef] = useState(null);

  const prevHandler = () => {
    swiperRef.slidePrev();
  };

  const nextHandler = () => {
    swiperRef.slideNext();
  };

  return (
    <div className="capabilities-background" ref={ref}>
      <div className="section-content mobile-padding-all">
        <div
          className="section-heading center-text white-text"
          data-aos="fade-up"
          data-aos-duration="700"
        >
          {content?.Title}
        </div>
        {!isMobile ? (
          <div className="card-section">
            {content?.Card?.map((card, index) => {
              return (
                <CapaCard
                  title={card?.Title}
                  desc={card?.Description}
                  mainImage={getStrapiMedia(card?.Image?.url)}
                  flipDelay={index + 1 + "00"}
                />
              );
            })}
          </div>
        ) : (
          <div>
            <Swiper
              effect={"flip"}
              grabCursor={true}
              // pagination={true}
              // navigation={true}
              modules={[EffectFlip, Pagination, Navigation]}
              className="mySwiper"
              onSwiper={(swiper) => setSwiperRef(swiper)}
            >
              {content?.Card?.map((card, index) => {
                return (
                  <SwiperSlide>
                    <CapaCard
                      title={card?.Title}
                      desc={card?.Description}
                      mainImage={getStrapiMedia(card?.Image?.url)}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
            <div className="swiper-controls">
              <Button
                variant="outlined"
                className="slider-button-prev"
                onClick={prevHandler}
              >
                <ArrowLeftOutlined />
              </Button>
              <Button
                variant="outlined"
                type=""
                className="slider-button-next"
                onClick={nextHandler}
              >
                <ArrowRightOutlined />
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});
export default Capabilities;
